import { datadogLogs } from '@datadog/browser-logs';
import { IFormCustomerFieldNames } from 'app/pages/frames/components/Form/FormCustomer/interface';
import { IShippingContact } from 'app/pages/frames/components/Form/FormShipping/interface';
import { AnalyticEvents } from 'app/util/constants';

export const sendFormAnalytics = (
  customerInfo: IFormCustomerFieldNames,
  id: string,
  companyId: string,
  type: string,
) => {
  for (const property in customerInfo) {
    if (property in AnalyticEvents) {
      sendAnalytic(AnalyticEvents[property], id, companyId, type);
    }
  }
};

export const sendShippingContactAnalytics = (
  shippingContact: IShippingContact,
  id: string,
  companyId: string,
  type: string,
) => {
  const { address } = shippingContact;
  for (const property in address) {
    if (property in AnalyticEvents) {
      sendAnalytic(AnalyticEvents[property], id, companyId, type);
    }
  }

  if ('phone' in shippingContact && 'phone' in AnalyticEvents) {
    sendAnalytic(AnalyticEvents.phone, id, companyId, type);
  }
};

export const sendAnalytic = (eventName: string, id: string, companyId: string, type = '') => {
  datadogLogs.logger.info(eventName, {
    name: eventName,
    orderId: id,
    companyId: companyId,
    type: type,
  });

  window.gtag('event', eventName, {
    company_id: companyId,
    order_id: id,
    type: type,
  });
};
